import { useState } from 'react'
import { Button, Field, useToast } from '../../ds/index'
import { post } from '../../lib/api'
import { PhoneAlerts, isIos, isInstalled } from '../../components/PhoneAlerts'

const WORDS = {
  off: 'Your phone buzzes the moment a lead comes in, so you can follow up while it is fresh. Alerts are for your leads and your account only.',
  on: 'New leads buzz here within seconds.',
}

/**
 * Lead alerts for a business's phone (the reps' alerts, on the portal's own
 * routes). On an iPhone, alerts work only in the home-screen app, and that app
 * does not share Safari's sign-in: a business that signed up without a password
 * chooses one first, or it could not get in there.
 */
export function ClientAlerts({ hasPassword, onChange }: { hasPassword: boolean; onChange?: () => void }) {
  const needsPassword = !hasPassword && isIos() && !isInstalled()
  return (
    <PhoneAlerts base="/api/client/push" appName="Handpicked" words={WORDS} onChange={onChange}
      beforeInstall={needsPassword ? <PasswordFirst onDone={() => onChange?.()} /> : null} />
  )
}

function PasswordFirst({ onDone }: { onDone: () => void }) {
  const toast = useToast()
  const [pw, setPw] = useState('')
  const [busy, setBusy] = useState(false)
  const save = async () => {
    setBusy(true)
    try { await post('/api/client/setup/password', { password: pw }); setPw(''); toast('Password set. Use it to sign in on your home screen.', 'pos'); onDone() } catch (e) { toast((e as Error).message, 'neg') } finally { setBusy(false) }
  }
  return (
    <div className="alert-password">
      <p className="mailbox-note" style={{ margin: 0 }}><strong>First, choose a password.</strong> The home-screen app signs you in on its own, with your email and this password.</p>
      <div className="row-tight" style={{ alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <Field label="Password (at least 8 characters)" id="alerts-pw" type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} />
        <Button onClick={save} disabled={busy || pw.length < 8}>{busy ? 'Saving' : 'Set password'}</Button>
      </div>
    </div>
  )
}
